module.exports = __webpack_public_path__ + "img/Rectangle 1191.db28f2b8.png";